import { render, staticRenderFns } from "./page-build.vue?vue&type=template&id=1f001deb&scoped=true"
import script from "./page-build.vue?vue&type=script&lang=js"
export * from "./page-build.vue?vue&type=script&lang=js"
import style0 from "./page-build.vue?vue&type=style&index=0&id=1f001deb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f001deb",
  null
  
)

export default component.exports